module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-BoldItalic.dcbe9869.woff";